import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const getStripeAccountLink = async ({
  token,
}: APIRequest): APIResponsePromise<{ url: string }> =>
  await _callBackend(
    '/integrations/get_stripe_account_link',
    'GET',
    null,
    token,
  );

export const checkStripeIntegration = async ({
  token,
}: APIRequest): APIResponsePromise<{
  connected: boolean;
  stripe_account_type: string;
  pending: boolean;
}> =>
  await _callBackend(
    '/integrations/check_stripe_integration',
    'GET',
    null,
    token,
  );
